import merge from "lodash/merge";
import { Theme } from "common";

/**
 * PEP specific style overrides to the AS-Common Theme definitions
 */
const STANFORD_TEXT_GRAY = "#333333";
const STANFORD_TEXT_ERROR_RED = "#FF0000";
const STANFORD_LINK_BLUE = "#007C92";
const STANFORD_TEXT_GREEN = "#009B76";
const themeOverrides = {
  palette: {
    pepGray: {
      main: STANFORD_TEXT_GRAY,
    },
    pepRed: {
      main: STANFORD_TEXT_ERROR_RED,
    },
    primary: {
      dark: STANFORD_LINK_BLUE,
      green: STANFORD_TEXT_GREEN,
    },
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: "15px",
          "& a": {
            textDecoration: "none",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-input": {
            fontSize: "15px",
          },
          "& .MuiInputLabel-root": {
            fontSize: "15px",
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        option: {
          fontSize: "15px",
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {},
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: "15px",
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: "none",
          "&:hover": {
            textDecoration: "underline",
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h5: {
          fontWeight: 400,
          fontSize: "22.5px",
          lineHeight: "30px",
        },
      },
    },
  },
};

// lodash.merge to insert our overrides
export const appTheme = merge(Theme, themeOverrides);
